import { gql } from '@apollo/client';
import {
  AnalysisFieldsFragment,
  AnalysisInfoFieldsFragment,
  AnalysisMetaFieldsFragment,
  AnalysisSummaryFieldsFragment,
} from './fragments';

export const GET_ANALYSIS = gql`
  query Analysis(
    $analysisId: ID!
    $refresh: Boolean = false
    $populateBuilder: Boolean = false
  ) {
    analysis(analysisId: $analysisId, refresh: $refresh) {
      ...AnalysisMetaFields
      ...AnalysisFields
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${AnalysisFieldsFragment}
`;

/**
 * DO NOT SELECT `data` field in this query for performance reasons
 * The special flag: `fillData: false` hints Kobol to skip executing
 * pending analysis and load the data from completed ones. This flag should
 * be removed when Kobol is able efficiently fill the data only if it is
 * requested.
 */
export const GET_ANALYSIS_INFO = gql`
  query GetAnalysisInfo($analysisId: ID!) {
    analysis(analysisId: $analysisId, fillData: false) {
      ...AnalysisInfoFields
    }
  }
  ${AnalysisInfoFieldsFragment}
`;

export const GET_ANALYSIS_SUMMARY = gql`
  query GetAnalysisSummary($analysisId: ID!) {
    analysis(analysisId: $analysisId) {
      ...AnalysisSummaryInfoFields
    }
  }
  ${AnalysisSummaryFieldsFragment}
`;
